import React, { HTMLAttributes, useState } from "react";
import { observer } from "mobx-react-lite";
import moment from "moment";
import CommonModal from "components/App/commonModal";
import cx from "classnames";

import { Hooks } from "@xt/xtbase";
const { useTranslation, useDocumentWidth } = Hooks;
// import store from "store";

import styles from "./index.module.less";

interface Props extends HTMLAttributes<HTMLDivElement> {
  attr?: any;
  isShowModal: boolean;
  datames: any;
  onClose?(): void;
}

const Schedule: React.FC<Props> = ({ className, onClose, isShowModal, title, datames }) => {
  const t = useTranslation();
  const [data, setdata] = useState(new Date())
  // const {isLogin} = store.user;
  const confirmTime = (payload) => {
    if (payload) {
      let now = new Date(moment(payload.timeMs).valueOf()).getHours();
      let nowmin = new Date(moment(payload.timeMs).valueOf()).getMinutes();
      return now + ":" + (nowmin > 9 ? nowmin : "0" + nowmin);
    }
    return "";
  };

  const jumpactivity = (item)=> {
    if (item && item.url) {
      window.open(item.url);
    }
  }

  return (
    <>
     <div className={cx(`${styles.modalAll}`, className)}>
      <CommonModal width={900} title={title} isShowModal={isShowModal} onClose={onClose} commonModal={styles.commonModal}>
        <div className={cx(`${styles.modalContent}`, className)}>
          <div className={cx(`${styles.modayBody}`, className)}>
            <div className={cx(`${styles.modayBodyContent}`, className)}>
              {datames &&
                datames.activity &&
                datames.activity.map((item, index) => {
                  return (
                    <div onClick={()=> jumpactivity(item)} key={index} className={cx(`${styles.modalLise}`, className)}>
                      <div className={cx(`${styles.modalHeader}`, className)}>
                        <div className={cx(`${styles.modalActivity}`, className)}>{item.typeName}</div>
                        <div className={cx(`${styles.modalTime}`, className)}>
                          {confirmTime(item)}
                          {item.url ? <span className={cx(`${styles.arrowTime}`, className)}>&gt;</span> : null}
                        </div>
                      </div>
                      <h3 className={cx(`${styles.modalTit}`, className)}>{item.name}</h3>
                      <div className={cx(`${styles.modalCon}`, className)}>{item.context}</div>
                    </div>
                  );
                })}
            </div>
          </div>
        </div>
      </CommonModal>
     </div>
    </>
  );
};

export default observer(Schedule);
// export default Main;
